import { LinkPre } from './ui/LinkPre';
import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MdClose } from 'react-icons/md';
import read from '../assets/readcv.png'

const Popup = ({ isOpen, onClose }) => {
  // Disable scrolling when the popup is open
  useEffect(() => {
    if (isOpen) {
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '0px';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '0px';
    };
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 h-screen z-50 flex items-center justify-center bg-zinc-100 dark:bg-black dark:bg-opacity-50 bg-opacity-50"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: 'spring', damping: 25, stiffness: 500 }}
            className="bg-zinc-200 dark:bg-zinc-950 lg:p-8 p-6 rounded-lg shadow-xl max-w-md w-full mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center lg:mb-8 mb-5 sm:mb-6">
              <h2 className="md:text-3xl text-xl font-medium text-center mx-auto  md:font-semibold text-zinc-800 dark:text-zinc-50">Choose Resume Format</h2>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
              >
                <MdClose size={24} />
              </button>
            </div>
            <div className="space-y-4 flex flex-col gap-1 sm:gap-2">
              <a href='https://drive.google.com/file/d/1GUhmaekCls9KjZiwBplkEZaZw5y8H7cH/view?usp=sharing' target='_blank'><LinkPre url='https://drive.google.com/file/d/1GUhmaekCls9KjZiwBplkEZaZw5y8H7cH/view?usp=sharing' className="font-bold my-1"> <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="w-full py-3 px-4 bg-blue-500 text-white rounded-md font-medium hover:bg-blue-600 transition-colors"

              >

                View Standard Resume
              </motion.button>  </LinkPre> </a>
              <a href='https://read.cv/vivekkhule' target='_blank'><LinkPre url='https://read.cv/vivekkhule' className="font-bold my-1"> <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="w-full py-3 px-4 bg-indigo-500 text-white rounded-md font-medium hover:bg-indigo-600 transition-colors"

              >

                View Detailed Resume
              </motion.button>  </LinkPre> </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Popup;
